import { Stack, Tooltip } from "@servicetitan/design-system";
import { useDependencies } from "@servicetitan/react-ioc";
import { observer } from "mobx-react";
import { EHStore } from "../stores/eh.store";
import { EHModulesHeaderListButton } from "./eh-modules-header-list-button/eh-modules-header-list-button";
import { HelpCenterLegacy } from "./help-center-legacy/help";

export const EHModulesHeaderList = observer(() => {
    const [{ headerModules }] = useDependencies(EHStore);

    return (
        <Stack spacing={1} className="m-r-2">
            {headerModules.map((m) => {
                return (
                    <Stack.Item key={`module-header-${m.id}`}>
                        {/* @ts-expect-error portalDataAttributes only expects data attributes, but can also be used to pass className */}
                        <Tooltip text={m.name} direction="bottom" portal portalDataAttributes={{ className: "m-t-1" }}>
                            <EHModulesHeaderListButton module={m} />
                        </Tooltip>
                    </Stack.Item>
                );
            })}
            <HelpCenterLegacy />
        </Stack>
    )
});